import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

/**
 * デモ用に事前登録された唯一のユーザ。
 * 静的フロントエンド (S3 配信) のみで完結させたいので、
 * 認証バックエンドを持たずクライアント側で固定値を比較する。
 */
const DEMO_USERNAME = "demo";
const DEMO_PASSWORD = "password";

export type AuthStatus = "anonymous" | "authenticated";

export interface AuthState {
  status: AuthStatus;
  username: string | null;
  /**
   * 認証成功時は true を返し store を更新、失敗時は false を返す。
   */
  login(username: string, password: string): boolean;
  logout(): void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        status: "anonymous",
        username: null,

        login(username, password) {
          if (username === DEMO_USERNAME && password === DEMO_PASSWORD) {
            set({ status: "authenticated", username }, false, "auth/login");
            return true;
          }
          return false;
        },

        logout() {
          set({ status: "anonymous", username: null }, false, "auth/logout");
        },
      }),
      {
        name: "factory-twin-auth",
        partialize: (s) => ({ status: s.status, username: s.username }),
      },
    ),
    { name: "AuthStore" },
  ),
);
